module.exports = __webpack_public_path__ + "img/google-map.afa46d42.png";